import NfseController from '@/controller/NfseController'
import NfseWorkflow from './nfseWorkflow'
import { createAttemptStore } from './nfseAttemptStore'
import { userHasPermission } from '@/helpers/userPermissions'

const readStorage = key => {
  try { return JSON.parse(localStorage.getItem(key) || 'null') } catch (error) { return null }
}
export default {
  data() { return { flow: null, sessionChanged: false } },
  computed: {
    fiscalUser() { return this.$store?.state?.autheasy?.user || readStorage('user') },
    fiscalEmpresa() { return this.$store?.state?.autheasy?.currentEmpresa || readStorage('currentEmpresa') },
    fiscalScopeKey() { return `${this.fiscalEmpresa?.id || ''}:${this.fiscalUser?.id || ''}` },
  },
  watch: {
    fiscalScopeKey() {
      this.flow.changeScope({ empresaId: this.fiscalEmpresa?.id, userId: this.fiscalUser?.id })
      this.flow.controller = new NfseController(this.fiscalUser, this.fiscalEmpresa)
      this.flow.attempts = createAttemptStore(this.flow.scope)
      if (this.resetFiscalPage) this.resetFiscalPage()
    },
  },
  created() {
    this.flow = new NfseWorkflow(new NfseController(this.fiscalUser, this.fiscalEmpresa), { empresaId: this.fiscalEmpresa?.id, userId: this.fiscalUser?.id })
    this.flow.attempts = createAttemptStore(this.flow.scope)
    window.addEventListener('storage', this.onFiscalStorage)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.onFiscalStorage)
    this.flow.dispose()
  },
  methods: {
    canFiscal(permission) { return !this.sessionChanged && Boolean(this.fiscalEmpresa?.id && userHasPermission(this.fiscalUser, permission)) },
    onFiscalStorage(event) {
      if (!event.key || ['user', 'currentEmpresa'].includes(event.key)) {
        this.sessionChanged = true
        this.flow.changeScope({})
        if (this.resetFiscalPage) this.resetFiscalPage()
        this.flow.state.message = 'Empresa ou sessão alterada em outra aba. Recarregue a página para continuar.'
      }
    },
  },
}
